import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
  ModalSheetSection,
} from 'components/ModalSheet'
import Button from 'components/Button'
import styles from './ManageSupportingItems.sass'
import ManageSupportingItemsViewModel, {
  SupportingItemViewModel,
} from './ManageSupportingItemsViewModel'
import { SwitchCheckbox } from 'components/SwitchCheckbox'
import Checkbox from 'components/Checkbox'

interface Props {
  vm: ManageSupportingItemsViewModel
}

export default observer(function ManageSupportingItemsModalForm({ vm }: Props) {
  return (
    <ModalSheet
      disableCloseOnOutsideClick
      showing={vm.showing}
      onRequestClose={vm.close}
    >
      <ModalSheetHeader withCloseButton bordered>
        <ModalSheetTitle emphasized>Manage supporting items</ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetSection spaced>
          <div className={styles.heading}>
            <div>Select all that apply</div>
            <div>Mark as required</div>
          </div>
          <div>
            <div className={styles.headingSection}>Inputs</div>
            {vm.supportingItemFromInputsViewModels.map((si, index) => (
              <SupportingItemSelector key={index} vm={si} />
            ))}
          </div>
          <div>
            <div className={styles.headingSection}>Document types</div>
            {vm.supportingItemFromDocumentTypesViewModels.map((si, index) => (
              <SupportingItemSelector
                key={index + vm.supportingItemFromInputsViewModels.length}
                vm={si}
              />
            ))}
          </div>
        </ModalSheetSection>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            dataTest="inventory-item-modal-close-button"
            onClick={vm.close}
            type="default"
          >
            Close
          </Button>

          <Button onClick={vm.submit} form="addItemForm" type="primary">
            {vm.totalSelected === 1
              ? `Assign ${vm.totalSelected} item`
              : `Assign ${vm.totalSelected} items`}
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

interface SupportingItemSelectorProps {
  vm: SupportingItemViewModel
}

const SupportingItemSelector = observer(function ({
  vm,
}: SupportingItemSelectorProps) {
  return (
    <div className={styles.supportingItem}>
      <div className={styles.selector}>
        <label className={styles.label}>
          <Checkbox checked={vm.requested} onChange={vm.toggleRequested} />
          <div className={styles.labelText}>{vm.name}</div>
        </label>
      </div>
      <div>
        <SwitchCheckbox
          noText
          disabled={!vm.requested}
          value={vm.required}
          onChange={vm.toggleRequired}
        />
      </div>
    </div>
  )
})
